import Tree from 'rc-tree'
import React, { useContext, useEffect, useState } from 'react'
import LightTooltip from '../../../../commonComponents/LightTooltip'
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, InputLabel, Menu, MenuItem, OutlinedInput, Radio, RadioGroup, Select, Stack, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import { scrollToSelectedItem, findParentLoopNodes, isParentKeyValueTrueNested, deepSetValueLogWFItemDetails, validateWorkflowItemName } from '../../../../utils/utilFunctions'
import { cloneDeep } from "lodash"
import { eachDeep } from "deepdash-es/standalone"
import { MoreHorizOutlined } from "@mui/icons-material"
import { loopTypeOptions, SystemDataListArray, TRANSLATE_OUTBOUND_CONDITION_MAPPING_2, workflowOperatorsDropDown } from '../../../../constants/constantList'
import { useDispatch, useSelector } from 'react-redux'
import { lgDocPath } from '../../../../constants/languageDocPaths'
import { api } from '../../../../redux/api'
import WorkflowSourceType from '../../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType'
import LabeledCheckbox from '../../../TemplateProperties/TPCheckbox'
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild'
import { treeActions } from '../../../../redux/slices/treeSlice'
import { PatternControl } from '../../Forms/PatternControl'
import WorkflowSessionModal from '../../WorkflowSessionModal'
import DelimiterDialog from '../../../TemplateProperties/DelimiterDialog'
import ErrorModal from '../../Forms/FieldDataValidation/ErrorModal'

const LoopProperties = () => {

  const { t } = useTranslation()
  const [selectedKey, setSelectedKey] = React.useState([])
  const [expandedKeys, setExpandedKeys] = React.useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)
  const conditionRef = React.useRef(null)
  const [treeData, setTreeData] = React.useState([])
  const [name, setName] = useState("")
  const [loopType, setLoopType] = useState("")
  const [listValue, setListValue] = useState("")
  const [loopValue, setLoopValue] = useState("")
  const [open, setOpen] = React.useState(false)
  const [workflowItemDialogMaxLoop, setWorkflowItemDialogMaxLoop] = useState(false)
  const [workflowItemDialogLoopList, setWorkflowItemDialogLoopList] = useState(false)
  const [workflowItemDialogLoopValue, setWorkflowItemDialogLoopValue] = useState(false)
  const [doNotLog, setDoNotLog] = React.useState(false)
  const [disableWFItem, setDisableWFItem] = React.useState(false)
  const [concurrent, setConcurrent] = React.useState(false)
  const [isDoNotLogDisabled, setIsDoNotLogDisabled] = React.useState(false)
  const [selectedNode, setSelectedNode] = React.useState({})
  const [loopDelimeter, setLoopDelimeter] = useState("")
  const [recordDelimiterDialog, setRecordDelimiterDialog] = useState(false);
  const { account, baseUrl, lang } = useSelector(state => state.queryParams);
  const [maxLoop, setMaxLoop] = useState("")
  // Name validation states
  const [nameErrorModal, setNameErrorModal] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState('');
  const [accountKeys, setAccountKeys] = useState([]);
  const [tradingpartnerKeys, setTradingPartnerKeys] = useState([]);
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const rightSelectedNode = rightTree.tree[rightTree.currentTab].selectedNode;

  const operatorDropdown = [{ value: t("SELECT"), text: t("SELECT") }, ...workflowOperatorsDropDown].map((operator, index) => {
    return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
  })

  const booleanOperationDropdown = [{ value: "TRUE", text: t("TRUE") }, { value: "FALSE", text: t("FALSE") }].map((operator, index) => {
    return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
  })

  const loopTypeDropDown = loopTypeOptions.map((operator, index) => {
    return (<MenuItem key={index} value={operator.value}>{t(operator.text)}</MenuItem>)
  })


  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const saveToRedux = (key, value, bulk) => {
    const clonedData = cloneDeep(translatedData);
    let found = false;
    eachDeep(clonedData, (obj) => {
      if (found) return;
      if (obj?.key === rightSelectedNode?.key) {
        found = true;
        if (key === "LOG_WFITEM_DETAILS") {
          obj[key] = value === "TRUE" ? "TRUE" : "FALSE";
          obj["children"] = deepSetValueLogWFItemDetails(obj?.children, value);
        }
        else if (key) {
          if (key === "NAME") {
            obj[key] = value || "UNNAMED";
            obj["title"] = value || "UNNAMED";
          } else if (key === "WF_SESSION_NAME" || key === "FORMAT_WFSESSION_VAR") {

          } else obj[key] = value;
        }
        else if (key === "LOOP_TYPE") {
          const toBeDeletedKeys = ["LOOP_OVER_LIST", "LOOP_OVER_VALUE", "CONDITION", "LOOP_DELIM"];
          toBeDeletedKeys.forEach((e) => {
            if (obj?.hasOwnProperty(e)) delete obj[e];
          });
          obj[key] = value;
        }
        else {
          Object.keys(bulk).forEach((e) => {
            obj[e] = bulk[e];
          });
        }

        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: rightTree.currentTab,
            data: obj,
          })
        );
      }
    });
    dispatch(
      treeActions.setRightTreeTransData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: clonedData,
      })
    );
  }

  const submitHandler = (data) => {
    const getCleanedData = (data, operator) => {
      return data?.map(e => {
        const newObj = {
          ...e,
          ...((!e?.hasOwnProperty("CHILDOPERATOR") && operator) ? { OPERATOR: operator } : {}),
          ...(e?.children?.length ? { CONDITION: getCleanedData(e?.children, e?.CHILDOPERATOR) } : {})
        }
        const keysRemoved = ["key", "title", "children"];

        keysRemoved.forEach(e => {
          if (newObj?.hasOwnProperty(e) || newObj[e] === null) delete newObj?.[e];
        })

        Object.keys(newObj).forEach((key) => {
          if (newObj[key] === undefined || newObj[key] === null || key.toLowerCase() === key) delete newObj[key];
        });

        return newObj;
      })
    }
    const cleanedData = getCleanedData(data);
    saveToRedux("CONDITION", cleanedData);
    setOpen(false)
  }

  const getLoopType = (node) => {
    if(node?.LOOP_TYPE) return node?.LOOP_TYPE;
    if (node?.LOOP_OVER_LIST) return "LOOP_TYPE_LIST";
    if (node?.LOOP_OVER_VALUE) return "LOOP_TYPE_VALUE";
    if (node?.CONDITION) return "LOOP_TYPE_CONDITION";
    return t("SELECT");
  }

  useEffect(() => {
    setDoNotLog(rightSelectedNode?.LOG_WFITEM_DETAILS === "FALSE")
    setConcurrent(rightSelectedNode?.CONCURRENT === "TRUE")
    setDisableWFItem(rightSelectedNode?.ENABLED === "FALSE")
    setName(rightSelectedNode?.NAME || "UNNAMED")
    setMaxLoop(rightSelectedNode?.MAX_LOOPS || "")
    setLoopType(getLoopType(rightSelectedNode))
    setListValue(rightSelectedNode?.LOOP_OVER_LIST || "")
    setLoopValue(rightSelectedNode?.LOOP_OVER_VALUE || "")
    dataToRCTree(rightSelectedNode?.CONDITION || [], true)
    setLoopDelimeter(rightSelectedNode?.LOOP_DELIM || "")
    
    // Check if parent loops have "Do not log details" enabled
    if (rightSelectedNode?.key && translatedData) {
      const parentLoops = findParentLoopNodes(translatedData, rightSelectedNode.key);
      const isLogWFItemDetailsFalse = isParentKeyValueTrueNested("LOG_WFITEM_DETAILS", "FALSE",translatedData, rightSelectedNode);
      setIsDoNotLogDisabled(isLogWFItemDetailsFalse);
    } else {
      setIsDoNotLogDisabled(false);
    }
  }, [rightSelectedNode?.key])


  const handleMenuClose = (source) => {
    setAnchorEl(null);
    if (source) {
      const data = JSON.parse(JSON.stringify(treeData));
      const newNode =
        source === "CONDITION" ? conditionNode : compoundConditionNode;
      if (!selectedKey?.length) {
        data.push(newNode);
        setSelectedKey(["cf-0"]);
        setSelectedNode({ key: "cf-0", ...newNode });
        if (source === "COMPOUND_CONDITION") setExpandedKeys(["cf-0"]);
      } else {
        const keyArray = selectedKey?.[0]?.split("-") || [];
        const [pre, ...rest] = keyArray;
        let tempData = data;
        for (let i = 0; i < rest.length; i++) {
          const index = Number(rest[i]);
          if (i === rest.length - 1) {
            if (tempData?.[index]?.CHILDOPERATOR && source === "CONDITION") {
              tempData = tempData?.[index]?.CONDITION;
              tempData.push(newNode);
              const key = selectedKey[0] + "-" + `${tempData?.length - 1}`;
              setSelectedKey([key]);
              setSelectedNode({ key, ...newNode });
              setExpandedKeys((prev) => [...prev, selectedKey[0]]);
            } else {
              tempData.push(newNode);
              keyArray.pop();
              keyArray.push(tempData.length - 1);
              setSelectedKey([keyArray?.join("-")]);
              setSelectedNode({ key: keyArray?.join("-"), ...newNode });
              if (source === "COMPOUND_CONDITION")
                setExpandedKeys((prev) => [...prev, keyArray?.join("-")]);
            }
          } else {
            tempData = tempData?.[index]?.CONDITION;
          }
        }
      }
      submitHandler(data);
      dataToRCTree(data);
    }
  };

  const dataToRCTree = (data, initialRender) => {
    const clonedData = JSON.parse(JSON.stringify(data));
    const loopData = (data, parentKey) => {
      return data?.map((e, i) => {
        if (e.CONDITION) {
          e.ICON_DISPLAY = "COMPOUND_CONDITION";
        } else {
          e.ICON_DISPLAY = "MAPPING_CONDITION";
        }
        e["key"] = parentKey + "-" + i;
        if (e?.CONDITION && e?.CHILDOPERATOR)
          e.title = e?.NAME + ` (${e.CHILDOPERATOR})`;
        else e.title = e?.NAME;
        if (e?.CONDITION?.length)
          e.children = loopData(e?.CONDITION, parentKey + "-" + i);
        else e.children = [];
        return e;
      });
    };

    const newData = loopData(clonedData, "cf");
    if (initialRender) {
      setSelectedKey(["cf-0"]);
      setSelectedNode(newData?.[0] || {});
    }
    setTreeData(newData);
  };

  const conditionsUpdater = (key, value, valuesObj) => {
    const rcTreeData = cloneDeep(treeData);
    eachDeep(rcTreeData, (obj) => {
      if (obj?.key && obj?.key === selectedNode?.key) {
        if (!key) {
          Object.keys(valuesObj).forEach((e) => {
            obj[e] = valuesObj[e];
          });
        } else obj[key] = value;
        setSelectedNode(obj);
      }
    });
    submitHandler(rcTreeData);
    dataToRCTree(rcTreeData);
  };

  const conditionDeleteHandler = () => {
    const data = JSON.parse(JSON.stringify(treeData));
    const keyArray = selectedKey?.[0]?.split("-") || [];
    const [pre, ...rest] = keyArray;
    let tempData = data;
    let parentNode = {};
    for (let i = 0; i < rest.length; i++) {
      const index = Number(rest[i]);
      if (i === rest.length - 1) {
        let key = selectedKey?.[0]?.split("-");
        if (index === 0) {
          if (key?.length === 2 && tempData?.length === 1) {
            setSelectedKey([]);
            setSelectedNode({});
          }
          if (key?.length === 2 && tempData?.length > 1) {
            setSelectedKey(["cf-0"]);
            setSelectedNode(tempData?.[1] || {});
          } else {
            if (key.length > 2) {
              key.pop();
              setSelectedKey([key.join("-")]);
              setSelectedNode(parentNode);
            } else {
              setSelectedKey([]);
              setSelectedNode({});
            }
          }
        } else {
          key?.pop();
          key?.push(index - 1);
          setSelectedKey([key?.join("-")]);
          setSelectedNode(tempData?.[index - 1] || {});
        }
        tempData.splice(index, 1);
      } else {
        parentNode = tempData?.[index];
        tempData = tempData?.[index]?.CONDITION;
      }
    }
    submitHandler(data);
    dataToRCTree(data);
  };

  const titleRender = (node) => {
    return <span data-key={`${node?.key}`}>{node.title}</span>;
  }

  const Icon = (node) => {
    return (
      <span
        data-key={`${node?.key}`}
        className={"tree-icon " + node.ICON_DISPLAY}
      ></span>
    );
  };

  const switcherIcon = (obj) => {
    if (obj.isLeaf) return;
    if (obj.expanded) return <ArrowDropDownIcon />;
    else return <ArrowRightIcon sx={{ color: "#666666" }} />;
  };

  const selectHandler = (selectedKeys, info) => {
    setSelectedKey([info.node.key])
    setSelectedNode(info.node)
  }

  const expandHandler = (expandedKeys, { expanded, node }) => {
    setExpandedKeys(expandedKeys)
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    const finalValue = type === "checkbox" ? checked ? "TRUE" : "FALSE" : value
    
    // If COMPARE is set to REGULAR_EXPRESSION, automatically set RECORD_TYPE2 to CONSTANT and clear inbound patterns
    if (name === "COMPARE" && value === "REGULAR_EXPRESSION") {
      conditionsUpdater(null, null, {
        COMPARE: value,
        RECORD_TYPE2: "CONSTANT",
        INBOUND_PATTERN: "",
        INBOUND_PATTERN_2: ""
      })
    } else {
      if(value !== t("SELECT")) conditionsUpdater(name, finalValue)
    }
  }

  useEffect(() => {
    if (conditionRef?.current) {
      scrollToSelectedItem(selectedKey, conditionRef);
    }
  }, [selectedKey]);

  useEffect(() => {
    if (selectedNode?.key && shouldShowBooleanOperators(selectedNode)) {
      if (selectedNode.COMPARE !== "TRUE" && selectedNode.COMPARE !== "FALSE") {
        conditionsUpdater(null, null, {
          COMPARE: "TRUE",
        });
      }
    }
  }, [selectedNode?.MAPNAME]);

  useEffect(() => {
    if (["ACCOUNT_KEYS", "TRADING_PARTNER_KEYS"].includes(selectedNode?.RECORD_TYPE2)) {
      const apiEndpoints = {
        'ACCOUNT_KEYS': api.endpoints.getAccountData,
        'TRADING_PARTNER_KEYS': api.endpoints.getTradingPartnersKeys
      }
      dispatch(apiEndpoints?.[selectedNode?.RECORD_TYPE2]?.initiate({
        account
      }, { forceRefetch: true }))
        .then(res => {
          if (res.data.current_state === "SUCCESS") {
            let data;

            if (res?.data?.data?.account_data_keys) {
              data = res?.data?.data?.account_data_keys.map(
                (o) => Object?.keys(o)?.[0]
              );
            } else if (res?.data?.data?.trading_partner_keys) {
              data = res?.data?.data?.trading_partner_keys;
            }
            if (data) {
              const newData = [t("SELECT"), ...data];
              const options = newData.map((opt, idx) => ({
                key: `${opt}-${idx}`,
                value: opt,
                label: opt
              }))
              if (selectedNode?.RECORD_TYPE2 === "ACCOUNT_KEYS") setAccountKeys(options?.map(e => {
                return <MenuItem value={e?.value}>{e?.value}</MenuItem>
              }));
              if (selectedNode?.RECORD_TYPE2 === "TRADING_PARTNER_KEYS") setTradingPartnerKeys(options?.map(e => {
                return <MenuItem value={e?.value}>{e?.value}</MenuItem>
              }));
            }
          }
        })
    }
  }, [selectedNode?.RECORD_TYPE2])

  const delimDisplay = (val, modal) => {
    if (val === undefined) return '';
    
    // Handle exact matches first
    if (val === "CR" || val === "%0D" || val === "\r") return "CR";
    if (val === "LF" || val === "%0A" || val === "\n") return "LF";
    if (val === "CRLF" || val === "%0D%0A" || val === "\r\n") return "CRLF";

    try { 
      val = decodeURIComponent(val);
    } catch (e) {
      // If decoding fails, continue with original value
    }
    
    // Handle strings that contain CR/LF characters (not just exact matches)
    let displayVal = val;
    
    // Replace actual CR+LF characters with "CRLF" for display
    if (displayVal.includes('\r\n')) {
      displayVal = displayVal.replaceAll('\r\n', 'CRLF');
    } else {
      // Handle individual CR and LF characters
      if (displayVal.includes('\r')) {
        displayVal = displayVal.replaceAll('\r', 'CR');
      }
      if (displayVal.includes('\n')) {
        displayVal = displayVal.replaceAll('\n', 'LF');
      }
    }
    
    // If the display value is short and doesn't contain CR/LF/CRLF, show ASCII codes
    if (displayVal.length < 3 && !displayVal.includes('CR') && !displayVal.includes('LF')) {
      return displayVal.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join(', ');
    }
    
    return displayVal;
  }

  /**
   * Check if concurrent workflow items exist in the workflow
   * @returns {boolean} - True if concurrent items exist
   */
  const hasConcurrentWorkflowItems = () => {
    if (!translatedData) return false;
    
    let hasConcurrentItems = false;
    
    // Recursively check all workflow items for CONCURRENT: "TRUE"
    const checkConcurrentItems = (items) => {
      if (!Array.isArray(items)) return;
      
      items.forEach(item => {
        if (item.CONCURRENT === "TRUE") {
          hasConcurrentItems = true;
          return;
        }
        if (item.children && item.children.length > 0) {
          checkConcurrentItems(item.children);
        }
      });
    };
    
    checkConcurrentItems(translatedData);
    return hasConcurrentItems;
  };

  /**
   * Determines if boolean operators (TRUE/FALSE) should be shown based on SWT logic
   * @param {Object} node - The selected condition node
   * @returns {boolean} - True if only boolean operators should be shown
   */
  const shouldShowBooleanOperators = (node) => {
    if (!node) return false;
    
    // Special source field names that only allow boolean operations
    const booleanOnlyFields = [
      "DATA_FOUND",
      "DATA_SENT", 
      "TRANSLATION_ERRORS",
      "COMMUNICATION_ERROR",
      "VALIDATION_ERRORS",
      "ELEM_VAL_ERR",
      "TRN_SET_VAL_ERR", 
      "FNCT_GRP_VAL_ERR",
      "SEG_VAL_ERR",
      "PROCESSING_ERRORS",
    ];
    
    // Check if MAPNAME is one of the special boolean-only fields
    if (node.MAPNAME && booleanOnlyFields.includes(node.MAPNAME)) {
      return true;
    }
    
    // Note: WF_ITEM_DEPENDENCY is handled separately by hiding the entire operator section
    // See line 721: selectedNode?.RECORD_TYPE !== "WF_ITEM_DEPENDENCY"
    
    return false;
  }

  const handleNameBlur = (eVal) => {
    const oldName = rightSelectedNode?.NAME || '';
    
    const validationResult = validateWorkflowItemName(
      eVal, 
      oldName, 
      translatedData, 
      rightSelectedNode?.key, 
      'LOOP_ITEM'
    );
    
    if (validationResult.isValid) {
      const newName = eVal?.trim() || '';
      setName(newName);
      if (newName !== oldName) {
        // Mark template as changed immediately to ensure flag is set before tab switch
        dispatch(treeActions.setTemplateChanged({ screen: parentScreen, data: true }));
        saveToRedux('NAME', newName);
        // Wait for debounce delay + buffer before dispatching
        setTimeout(() => {
          dispatch(treeActions.setIsInputFocusedFalse());
        }, 200);
      } else {
        // If no change, dispatch immediately
        setTimeout(() => {
          dispatch(treeActions.setIsInputFocusedFalse());
        }, 100);
      }
    } else {
      if (validationResult.errorMessage) {
        setNameErrorMessage(t(validationResult.errorMessage));
        setNameErrorModal(true);
      } else if (validationResult.shouldRevert) {
        setName(oldName);
      }
      // For error cases, dispatch immediately
      setTimeout(() => {
        dispatch(treeActions.setIsInputFocusedFalse());
      }, 100);
    }
  };

  const handleNameErrorModal = (isOpen) => {
    setNameErrorModal(isOpen);
    if (!isOpen) {
      const oldName = rightSelectedNode?.NAME || '';
      setName(oldName);
    }
  };



  return (
    <>
      <FormControl variant='outlined' className='width-100' size='small' sx={{ marginBottom: 2 }}>
        <InputLabel
          htmlFor='error-handler-name-input'
          sx={{ padding: "0 6px !important", left: "-5px" }}
        >
          {t('COL_NAME')}
        </InputLabel>
        <OutlinedInput
          id="error-handler-name-input"
          size='small'
          variant='outlined'
          fullWidth
          autoComplete='off' 
          value={name || ""} 
          endAdornment={<div style={styles.nameAdornment}>{`ID: ${rightSelectedNode?.ID || ""}`}</div>}
          onChange={(e) => {
            setName(e.target.value);
          }}
          onBlur={(e) => handleNameBlur(e.target.value)}
          onFocus={() => dispatch(treeActions.setIsInputFocusedTrue())}
        />
      </FormControl>
      <Box
        variant='outlined'
        sx={{ display: "flex", flexWrap: "wrap", my: 1 }}
        className='width-100'
        size='small'
      >
        <LabeledCheckbox
          label={t("LBL_LOG_NO_WFITEM_DETAILS")}
          handleCheck={(checked) => {
            if (!isDoNotLogDisabled) {
              setDoNotLog(checked);
              saveToRedux(
                "LOG_WFITEM_DETAILS",
                checked ? "FALSE" : "TRUE"
              );
            }
          }}
          checked={doNotLog}
          disabled={isDoNotLogDisabled || isDoNotLogDisabled}
        />
        <LabeledCheckbox
          label={t("LBL_RUN_CONCURRENTLY")}
          handleCheck={(checked) => {
            setConcurrent(checked);
            saveToRedux(
              "CONCURRENT",
              checked ? "TRUE" : "FALSE"
            );
          }}
          checked={concurrent}
        />
        <LabeledCheckbox
          label={t("LBL_DISABLE_WFITEM")}
          handleCheck={(checked) => {
            setDisableWFItem(checked);
            saveToRedux(
              "ENABLED",
              checked ? "FALSE" : "TRUE"
            );
          }}
          checked={disableWFItem}
        />
      </Box>
      <Stack spacing={2} my={2}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <TextField fullWidth size="small" label={t("LBL_LOOP_MAX")} name="MAX_LOOPS" value={maxLoop || ""} onChange={(e) => {
            const val = e?.target?.value ? e?.target?.value : "UNNAMED";
            setMaxLoop(val)
            saveToRedux("MAX_LOOPS", val);
          }} />
          <Button size='small' sx={{ width: "35px !important" }} onClick={() => {
            setWorkflowItemDialogMaxLoop({open: true, isFirstTime: true})
          }} variant='outlined'><MoreHorizOutlined /></Button>
        </Box>
        <TextField
          select
          fullWidth
          size='small'
          onChange={(e) => {
            setLoopType(e?.target?.value)
            e?.target?.value !== t("SELECT") && saveToRedux(null, null, {
              LOOP_TYPE: e?.target?.value,
              LOOP_OVER_LIST: null,
              LOOP_OVER_VALUE: null,
              CONDITION: null,
              LOOP_DELIM: null
            });
            setListValue("")
            setLoopValue("")
            setTreeData([])
            setSelectedNode({})
            setSelectedKey([])
          }}
          value={loopType}
          label={t("LBL_LOOP_TYPE")}
        >{loopTypeDropDown}</TextField>
      </Stack>
      {
        loopType === "LOOP_TYPE_CONDITION" ? <>
          <div style={styles.dialogHeader} className="dialog-header">
            {/* <InputLabel >{t("BTN_OUT_COND_PROPS")}: UNNAMED</InputLabel> */}
          </div>
          <div>
            <div
              style={{
                marginBottom: "4px",
                overflowX: "hidden",
                position: "relative",
              }}
              ref={conditionRef}
              className="div-textBox-conditional-field"
            >
              <div
                style={{
                  backgroundColor: "#F2F2F2",
                  position: "sticky",
                  top: "0",
                  zIndex: "1000",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "93%",
                    margin: "auto",
                    padding: "2px",
                  }}
                >
                  <div
                    style={{
                      color: "#666666",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {t("LBL_CONDITIONS")}
                  </div>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <div>
                      <LightTooltip arrow onClick={handleMenuClick}>
                        <span
                          style={{ cursor: "pointer" }}
                          className="ADD_MUI"
                        ></span>
                      </LightTooltip>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => handleMenuClose()}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <MenuItem onClick={() => handleMenuClose("CONDITION")}>
                          {t("MNU_NEW_COND")}
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleMenuClose("COMPOUND_CONDITION")}
                        >
                          {t("MNU_NEW_COMP_COND")}
                        </MenuItem>
                      </Menu>
                    </div>
                    <LightTooltip
                      onClick={conditionDeleteHandler}
                      title={t("DELETE")}
                      arrow
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        className="DELETE_MUI"
                      ></span>
                    </LightTooltip>
                    {/* <LightTooltip
                                          onClick={conditionCopyHandler}
                                          title={t("MNU_COPY")}
                                          arrow
                                      >
                                          <span
                                              style={{ cursor: "pointer" }}
                                              className="FILE_COPY"
                                          ></span>
                                      </LightTooltip> */}
                  </div>
                </div>
              </div>
              <Tree
                titleRender={titleRender}
                treeData={treeData}
                icon={Icon}
                selectedKeys={selectedKey}
                switcherIcon={switcherIcon}
                onSelect={selectHandler}
                expandedKeys={expandedKeys}
                onExpand={expandHandler}
              />
            </div>
          </div>

          <Stack spacing={2} mt={2}>
            <TextField disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small" label={t("LBL_CONDITION_NAME")} name="NAME" value={selectedNode.NAME || ""} onChange={(e) => {
              const name = e?.target?.value ? e?.target?.value : "UNNAMED";
              conditionsUpdater("NAME", name);
            }} />
            {
              selectedNode?.hasOwnProperty("CHILDOPERATOR") ?
                <>
                  <InputLabel>{t("LBL_SEL_OPER_FOR_COND_CONTAINED_WITHIN_COMP_COND")}</InputLabel>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    ml={3}
                    disabled={!selectedNode?.hasOwnProperty("key")}
                  >
                    <FormLabel>{t("LBL_COMPOUND_OPER")}</FormLabel>
                    <RadioGroup
                      row
                      name="CHILDOPERATOR"
                      value={selectedNode?.CHILDOPERATOR || "AND"}
                      onChange={(e) => {
                        conditionsUpdater("CHILDOPERATOR", e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value={"OR"}
                        control={<Radio />}
                        label={"OR"}
                      />
                      <FormControlLabel
                        value={"AND"}
                        control={<Radio />}
                        label={"AND"}
                      />
                    </RadioGroup>
                  </FormControl>
                </> : <>
                  <InputLabel>{t("LBL_DATA_MAPPING_")} 1</InputLabel>
                  <WorkflowSourceType
                    disabled={!selectedNode?.hasOwnProperty("key")}
                    source={"LOOP"}
                    node={
                      {
                        key: selectedNode?.key,
                        RECORD_TYPE: selectedNode?.RECORD_TYPE,
                        WFITEM: selectedNode?.WF_ITEM_1,
                        OUTBOUND_NAME: selectedNode?.OUTBOUND_1,
                        MAPNAME: selectedNode?.MAPNAME,
                        WF_ITEM_DEPENDENCY_TIMEOUT: selectedNode?.WF_ITEM_DEPENDENCY_TIMEOUT,
                        WF_ITEM_ID: selectedNode?.WF_ITEM_ID_1,
                        COMPARE: selectedNode?.COMPARE,
                        CALL_WORKFLOW_ACCOUNT: selectedNode?.CALL_WORKFLOW_ACCOUNT_ONE,
                        CALL_WORKFLOW: selectedNode?.CALL_WORKFLOW_ONE,
                        CALL_WORKFLOW_GROUP: selectedNode?.CALL_WORKFLOW_GROUP_ONE,
                      }
                    }
                    valuesHandler={(values) => {
                      conditionsUpdater(null, null, {
                        RECORD_TYPE: values?.RECORD_TYPE,
                        WF_ITEM_1: values?.WFITEM,
                        OUTBOUND_1: values?.OUTBOUND_NAME,
                        MAPNAME: values?.MAPNAME,
                        WF_ITEM_ID_1: values?.WF_ITEM_ID,
                        CALL_WORKFLOW_ACCOUNT_ONE: values?.CALL_WORKFLOW_ACCOUNT,
                        CALL_WORKFLOW_ONE: values?.CALL_WORKFLOW,
                        CALL_WORKFLOW_GROUP_ONE: values?.CALL_WORKFLOW_GROUP,
                        WF_ITEM_DEPENDENCY_TIMEOUT: values?.WF_ITEM_DEPENDENCY_TIMEOUT,
                        COMPARE: values?.COMPARE || selectedNode?.COMPARE,
                      })
                    }}
                    compareValueApplicable={true}
                    enableWorkflowItemDependencyOption={hasConcurrentWorkflowItems()}
                    showTimeout={true}
                    hideSourceTypeOptions={["PLUGIN", "PROCESSING_ERRORS", "STATUS_MESSAGES", "TRANSLATION_ERRORS"]}
                  />
                  <Divider />
                  {selectedNode?.RECORD_TYPE !== "WF_ITEM_DEPENDENCY" ? <><InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                    <div style={{ display: "flex" }}>
                      <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key")} control={<Checkbox name="COMPARE_ACTION_NOT" checked={selectedNode.COMPARE_ACTION_NOT === "TRUE"} onChange={handleChange} />} label={t("BTN_NOT")} />
                      <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                        <InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                        <Select MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200, // Adjust this value
                            },
                          },
                        }} size="small" name="COMPARE" value={selectedNode?.COMPARE || t("SELECT")} onChange={handleChange}>
                          {shouldShowBooleanOperators(selectedNode) ? booleanOperationDropdown : operatorDropdown}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ display: "flex" }}>
                      <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key")} control={<Checkbox name="COMPARE_ACTION_IGNORECASE" checked={selectedNode.COMPARE_ACTION_IGNORECASE === "TRUE"} onChange={handleChange} />} label={t("IGNORECASE")} />
                      <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key")} control={<Checkbox name="COMPARE_ACTION_TRIM" checked={selectedNode.COMPARE_ACTION_TRIM === "TRUE"} onChange={handleChange} />} label={t("LBL_TRIM_DATA")} />
                    </div>
                    {selectedNode?.COMPARE === "IS_DATE" ? <>
                      <PatternControl
                        inputId="fieldDecPattern"
                        inputLabel={t("LBL_PATTERN")}
                        pattern={selectedNode?.PATTERN}
                        setPattern={(val) => {
                          conditionsUpdater("PATTERN", val);
                        }}
                      />

                    </> : <></>}</> : <></>}
                  {
                    (!["ISNULL", "IS_NUMERIC", "IS_DATE", "TRUE", "FALSE"].includes(selectedNode.COMPARE)) ? <>
                      <Divider />
                      <InputLabel>{t("LBL_DATA_MAPPING_")} 2</InputLabel>
                      <WorkflowSourceType
                        disabled={!selectedNode?.hasOwnProperty("key")}
                        source={"LOOP"}
                        node={
                          {
                            key: selectedNode?.key,
                            RECORD_TYPE: selectedNode?.RECORD_TYPE2,
                            WFITEM: selectedNode?.WF_ITEM_2,
                            OUTBOUND_NAME: selectedNode?.OUTBOUND_2,
                            MAPNAME: selectedNode?.MAPNAME2,
                            VALUE: selectedNode?.VALUE,
                            INBOUND_PATTERN: selectedNode?.INBOUND_PATTERN_2,
                            WF_ITEM_ID: selectedNode?.WF_ITEM_ID_2,
                            CALL_WORKFLOW_ACCOUNT: selectedNode?.CALL_WORKFLOW_ACCOUNT_TWO,
                            CALL_WORKFLOW: selectedNode?.CALL_WORKFLOW_TWO,
                            CALL_WORKFLOW_GROUP: selectedNode?.CALL_WORKFLOW_GROUP_TWO,

                          }
                        }
                        valuesHandler={(values) => {
                          conditionsUpdater(null, null, {
                            RECORD_TYPE2: values?.RECORD_TYPE,
                            WF_ITEM_2: values?.WFITEM,
                            OUTBOUND_2: values?.OUTBOUND_NAME,
                            MAPNAME2: values?.MAPNAME,
                            WF_ITEM_ID_2: values?.WF_ITEM_ID,
                            CALL_WORKFLOW_ACCOUNT_TWO: values?.CALL_WORKFLOW_ACCOUNT,
                            CALL_WORKFLOW_TWO: values?.CALL_WORKFLOW,
                            CALL_WORKFLOW_GROUP_TWO: values?.CALL_WORKFLOW_GROUP,
                            INBOUND_PATTERN_2: values?.INBOUND_PATTERN,
                            VALUE: values?.VALUE,
                          })
                        }}
                        enableWorkflowItemDependencyOption={hasConcurrentWorkflowItems()}
                        addConstantControl={true}
                        hideSourceTypeOptions={["PLUGIN", "PROCESSING_ERRORS", "STATUS_MESSAGES", "TRANSLATION_ERRORS"]}
                      />
                    </> : <></>
                  }
                </>

            }
          </Stack>

        </> : <></>
      }

      {
        loopType === "LOOP_TYPE_LIST" ? <>
          <Stack spacing={2} my={2}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <TextField fullWidth size="small" label={t("LOOP_OVER_LIST")} name="LOOP_OVER_LIST" value={listValue || ""} onChange={(e) => {
                const val = e?.target?.value ? e?.target?.value : "UNNAMED";
                setListValue(val)
                saveToRedux("LOOP_OVER_LIST", val);
              }} />
              <Button size='small' sx={{ width: "35px !important" }}
                onClick={() => {
                  setWorkflowItemDialogLoopList({open: true, isFirstTime: true})
                }} variant='outlined'><MoreHorizOutlined /></Button>
            </Box>
            <FormControl className='width-100' size='small'>
              <TextField
                size='small'
                variant='outlined'
                className='width-100 delim-button'
                // label={t("LBL_REC_DELIM")}
                value={delimDisplay(loopDelimeter) || t("TXT_NO_DELIM_CHOSEN")}
                onClick={() => setRecordDelimiterDialog(true)}
                InputProps={{
                  readOnly: true,
                  sx: { textAlign: 'center' },
                  inputProps: { style: { textAlign: 'center' } }
                }}
              />
              <DelimiterDialog
                modalOpen={recordDelimiterDialog}
                close={() => setRecordDelimiterDialog(false)}
                handleInput={(val) => {
                  setLoopDelimeter(val)
                  saveToRedux("LOOP_DELIM", val);
                }}
                val={loopDelimeter || ''}
                name={'LOOP_DELIMITER'}
                from={'LOOP_DELIMITER'}
            />
            </FormControl>
          </Stack>
        </> : <></>
      }

      {
        loopType === "LOOP_TYPE_VALUE" ? <>
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <TextField fullWidth size="small" label={t("LOOP")} name="LOOP_OVER_VALUE" value={loopValue || ""} onChange={(e) => {
              const val = e?.target?.value ? e?.target?.value : "";
              setLoopValue(val)
              saveToRedux("LOOP_OVER_VALUE", val);
            }} />
            <Button size='small' sx={{ width: "35px !important" }} onClick={() => {
              setWorkflowItemDialogLoopValue({open: true, isFirstTime: true})
            }} variant='outlined'><MoreHorizOutlined /></Button>
          </Box>

        </> : <></>
      }

      <WorkflowSessionModal
        valueLabel={t("LOOP_OVER_LIST")}
        showAccountData={true}
        showCallingWorkflow={true}
        showDateAndTime={true}
        showSystemData={true}
        showWorkflowSession={true}
        openModal={workflowItemDialogLoopList}
        setModalOpen={setWorkflowItemDialogLoopList}
        handleClose={() => setWorkflowItemDialogLoopList({ open: false, isFirstTime: false })}
        initialValue={listValue}
        valuesHandler={(value) => {
          saveToRedux("LOOP_OVER_LIST", value)
          setListValue(value)
        }}
      />

      <WorkflowSessionModal
        valueLabel={t("LBL_LOOP_MAX")}
        showAccountData={true}
        showCallingWorkflow={true}
        showDateAndTime={true}
        showSystemData={true}
        showWorkflowSession={true}
        openModal={workflowItemDialogMaxLoop}
        setModalOpen={setWorkflowItemDialogMaxLoop}
        handleClose={() => setWorkflowItemDialogMaxLoop({ open: false, isFirstTime: false })}
        initialValue={maxLoop}
        valuesHandler={(value) => {
          saveToRedux("MAX_LOOPS", value)
          setMaxLoop(value)
        }}
      />

      <WorkflowSessionModal
        valueLabel={t("LOOP")}
        showAccountData={true}
        showCallingWorkflow={true}
        showDateAndTime={true}
        showSystemData={true}
        showWorkflowSession={true}
        openModal={workflowItemDialogLoopValue}
        setModalOpen={setWorkflowItemDialogLoopValue}
        handleClose={() => setWorkflowItemDialogLoopValue({ open: false, isFirstTime: false })}
        initialValue={loopValue}
        valuesHandler={(value) => {
          saveToRedux("LOOP_OVER_VALUE", value)
          setLoopValue(value)
        }}
      />

      {/* Error Modal for name validation */}
      <ErrorModal
        errorModal={nameErrorModal}
        setErrorModal={setNameErrorModal}
        errorMessage={nameErrorMessage}
        errorType={t('ERROR')}
        handleErrorModal={handleNameErrorModal}
      />

    </>
  )

}

export default LoopProperties



// Keep the condition node constants
const conditionNode = {
  "NAME": "UNNAMED",
  "COMPARE": "",
  "RECORD_TYPE": "SESSION_DATA",
  "RECORD_TYPE2": "SESSION_DATA",
  "WF_ITEM_DEPENDENCY_TIMEOUT": "5000",
  "PATTERN": "MM/dd/yy",
  "COMPARE_ACTION_TRIM": "FALSE",
  "COMPARE_ACTION_IGNORECASE": "FALSE",
  "COMPARE_ACTION_NOT": "FALSE",
  "BIT_MAP": ""

}

const compoundConditionNode = {
  "NAME": "COMPOUND CONDITION",
  "CHILDOPERATOR": "AND",
  "CONDITION": [
    {
      "NAME": "UNNAMED1",
      "OPERATOR": "AND",
      "COMPARE": "EQUALS",
      "RECORD_TYPE": "SESSION_DATA",
      "RECORD_TYPE2": "SESSION_DATA",
      "WF_ITEM_DEPENDENCY_TIMEOUT": "5000",
      "PATTERN": "MM/dd/yy",
      "COMPARE_ACTION_TRIM": "FALSE",
      "COMPARE_ACTION_IGNORECASE": "FALSE",
      "COMPARE_ACTION_NOT": "FALSE",
      "BIT_MAP": ""
    },
    {
      "NAME": "UNNAMED2",
      "OPERATOR": "AND",
      "COMPARE": "EQUALS",
      "RECORD_TYPE": "SESSION_DATA",
      "RECORD_TYPE2": "SESSION_DATA",
      "WF_ITEM_DEPENDENCY_TIMEOUT": "5000",
      "PATTERN": "MM/dd/yy",
      "COMPARE_ACTION_TRIM": "FALSE",
      "COMPARE_ACTION_IGNORECASE": "FALSE",
      "COMPARE_ACTION_NOT": "FALSE",
      "BIT_MAP": ""
    }
  ]
}


// Add some basic styles
const styles = {
  container: {
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
  },
  nameAdornment: {
    color: "#666666",
    fontSize: "9px",
    position: "absolute",
    right: "13px",
    top: "-6px",
    backgroundColor: "#FFF",
    zIndex: "2",
    padding: "0 5px",
    height: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}